import type { RawKeyedArrow } from 'chessboard/plugins/arrows/config/types';
import { ArrowType } from 'chessboard/plugins/arrows/config/types';
import { Core } from 'chessboard/core/config/types';
import { createKeyedArrow } from 'chessboard/plugins/arrows/model/create-keyed-arrow';
import { is } from 'src/utils/app/model/is';
import { isMark } from 'chessboard/plugins/markings/model/is-mark';
import { isType } from 'chessboard/plugins/markings/model/is-type';
import { isUnmark } from 'chessboard/plugins/markings/model/is-unmark';
import { init } from 'chessboard/plugins/arrows/event-handlers/init';

const checkBefore = (handler: Function) => (event: Core.Event, context: Core.Context) => {
  const isSetupMode = context.api.getMode().name === 'setup';
  const setupImprovements = context.api.getOptions().setupImprovements;

  if (setupImprovements && isSetupMode) {
    return;
  }

  handler(event, context);
};

/**
 * Event handlers for the arrows plugin.
 */
export function createArrowsEventHandlers() {
  return [
    { condition: isMark(ArrowType), handler: checkBefore(markArrow) },
    { condition: isUnmark(ArrowType), handler: checkBefore(unmarkArrow) },
    { condition: is(Core.InstanceEvents.RendererSet), handler: checkBefore(onRendererSet) },
  ];

  /**
   * Update the arrows on the board.
   */
  function onRendererSet(_event: Core.Event, context: Core.Context) {
    init(context);
  }
  /**
   * Mark the arrow.
   */
  function markArrow(event: Core.Event, context: Core.Context) {
    const { options, renderer } = context;
    const { data } = event;

    const arrows = data
      .filter(isType(ArrowType))
      .map((rawArrow: RawKeyedArrow) => createKeyedArrow({ rawArrow, options }));

    renderer?.addArrows(arrows, context);
  }
  /**
   * Unmark the arrow.
   */
  function unmarkArrow(event: Core.Event, context: Core.Context) {
    const { options, renderer } = context;
    const { data } = event;

    const arrows = data
      .filter(isType(ArrowType))
      .map((rawArrow: RawKeyedArrow) => createKeyedArrow({ rawArrow, options }));

    renderer?.removeArrows(arrows, context);
  }
}
